import { create } from 'zustand';
import { NexoyaImpactGroup, NexoyaImpactGroupRule, NexoyaPortfolioLabel } from '../types';

export interface TaxonomyFilterState {
  labelsFilter: NexoyaPortfolioLabel[];
  impactGroupsFilter: NexoyaImpactGroup[];
  impactGroupRulesFilter: NexoyaImpactGroupRule[];
  includeNoLabel: boolean;

  handleAddLabel: (label: NexoyaPortfolioLabel) => void;
  handleRemoveLabel: (label: NexoyaPortfolioLabel) => void;
  handleToggleNoLabel: () => void;

  handleAddImpactGroup: (impactGroup: NexoyaImpactGroup) => void;
  handleRemoveImpactGroup: (impactGroup: NexoyaImpactGroup) => void;

  handleAddImpactGroupRule: (impactGroupRule: NexoyaImpactGroupRule) => void;
  handleRemoveImpactGroupRule: (impactGroupRule: NexoyaImpactGroupRule) => void;

  resetTaxonomyFilters: (type?: 'labelsFilter' | 'impactGroups' | 'impactGroupRules') => void;
}

export const useTaxonomyFilterStore = create<TaxonomyFilterState>((set) => ({
  labelsFilter: [],
  impactGroupsFilter: [],
  impactGroupRulesFilter: [],
  includeNoLabel: false,

  handleAddLabel: (label) =>
    set((state) => ({
      labelsFilter: [...state.labelsFilter, label],
    })),

  handleRemoveLabel: (label) =>
    set((state) => ({
      labelsFilter: state.labelsFilter.filter((l) => l.labelId !== label.labelId),
    })),

  handleToggleNoLabel: () =>
    set((state) => ({
      includeNoLabel: !state.includeNoLabel,
    })),

  handleAddImpactGroup: (impactGroup) =>
    set((state) => ({
      impactGroupsFilter: [...state.impactGroupsFilter, impactGroup],
    })),

  handleRemoveImpactGroup: (impactGroup) =>
    set((state) => ({
      impactGroupsFilter: state.impactGroupsFilter.filter((ig) => ig.impactGroupId !== impactGroup.impactGroupId),
    })),

  handleAddImpactGroupRule: (impactGroupRule) =>
    set((state) => ({
      impactGroupRulesFilter: [...state.impactGroupRulesFilter, impactGroupRule],
    })),

  handleRemoveImpactGroupRule: (impactGroupRule) =>
    set((state) => ({
      impactGroupRulesFilter: state.impactGroupRulesFilter.filter(
        (igr) => igr.impactGroupRuleId !== impactGroupRule.impactGroupRuleId,
      ),
    })),

  resetTaxonomyFilters: (type) =>
    set(() => {
      if (!type) return { labelsFilter: [], includeNoLabel: false, impactGroupsFilter: [], impactGroupRulesFilter: [] };
      const resetMap = {
        labelsFilter: { labelsFilter: [] as NexoyaPortfolioLabel[], includeNoLabel: false },
        impactGroups: { impactGroupsFilter: [] as NexoyaImpactGroup[] },
        impactGroupRules: { impactGroupRulesFilter: [] as NexoyaImpactGroupRule[] },
      };
      return resetMap[type] || {};
    }),
}));
